export const itemData = [
  {
    img: 'assets/img_list/selin_cover.jpg',
    title: 'cover',
  },
  {
    img: 'assets/img_list/selin_1.JPEG',
    title: 'selin_1',
  },
  {
    img: 'assets/img_list/selin_2.JPEG',
    title: 'selin_2',
  },
  {
    img: 'assets/img_list/selin_3.jpg',
    title: 'selin_3',
  },
  {
    img: 'assets/img_list/selin_4.jpg',
    title: 'selin_4',
  },
  {
    img: 'assets/img_list/indonesia_now.JPG',
    title: 'indonesia_now_2023',
  },
  {
    img: 'assets/img_list/gfc_1.JPEG',
    title: 'gfc_1',
  },
  {
    img: 'assets/img_list/gfc_2.JPEG',
    title: 'gfc_2',
  },
  {
    img: 'assets/img_list/gfc_3.JPEG',
    title: 'gfc_3',
  },
  {
    img: 'assets/img_list/pic_1.JPG',
    title: 'pic_1',
  },
  {
    img: 'assets/img_list/imta_1.JPG',
    title: 'imta_1',
  },
  {
    img: 'assets/img_list/model.jpg',
    title: 'model_2022',
  },
  {
    img: 'assets/img_list/2022_nyfw.JPG',
    title: 'nyfw_2022',
  },
];